import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchRatePlans } from '@/renderer/services/accommodationService';

export function useRatePlans(propertyId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.ratePlans(propertyId ?? ''),
    queryFn: () => fetchRatePlans(propertyId!),
    enabled: !!propertyId,
    staleTime: 1000 * 60 * 5,
  });
}
